import { __assign } from "tslib";
import { getFocusStyle, HighContrastSelector, getHighContrastNoAdjustStyle } from 'office-ui-fabric-react/lib/Styling';
export var DefaultButtonStyles = function (props) {
    var _a, _b, _c, _d, _e;
    var theme = props.theme;
    if (!theme) {
        throw new Error('Theme is undefined or null.');
    }
    var palette = theme.palette, effects = theme.effects;
    return {
        root: __assign({ borderRadius: effects.roundedCorner2, backgroundColor: palette.white, border: "1px solid " + palette.neutralSecondaryAlt }, getFocusStyle(theme, { inset: 1 })),
        rootHovered: {
            backgroundColor: palette.neutralLighter,
            selectors: {
                '.ms-Button--primary': {
                    backgroundColor: palette.themeDarkAlt,
                },
            },
        },
        rootPressed: {
            backgroundColor: palette.neutralLight,
        },
        rootChecked: {
            backgroundColor: palette.neutralLight,
        },
        rootDisabled: {
            backgroundColor: palette.neutralLighter,
            borderColor: palette.neutralLighter,
            selectors: (_a = {},
                _a[HighContrastSelector] = {
                    color: 'GrayText',
                    borderColor: 'GrayText',
                    backgroundColor: 'Window',
                },
                _a),
        },
        splitButtonMenuButton: {
            background: 'transparent',
            borderTopRightRadius: effects.roundedCorner2,
            borderBottomRightRadius: effects.roundedCorner2,
            border: "1px solid " + palette.neutralSecondaryAlt,
            borderLeft: 'none',
        },
        splitButtonContainer: {
            selectors: {
                '.ms-Button--default': {
                    borderRight: 'none',
                    borderTopRightRadius: '0',
                    borderBottomRightRadius: '0',
                },
                '.ms-Button--primary': {
                    borderTopRightRadius: '0',
                    borderBottomRightRadius: '0',
                    border: 'none',
                    backgroundColor: palette.themePrimary,
                    selectors: {
                        ':hover': {
                            background: palette.themeDarkAlt,
                        },
                    },
                },
                '.ms-Button--primary + .ms-Button': {
                    backgroundColor: palette.themePrimary,
                    border: 'none',
                    selectors: (_b = {
                            ':hover': {
                                background: palette.themeDarkAlt,
                                selectors: (_c = {},
                                    _c[HighContrastSelector] = __assign({ color: 'Window', backgroundColor: 'Highlight' }, getHighContrastNoAdjustStyle()),
                                    _c),
                            }
                        },
                        _b[HighContrastSelector] = __assign({ color: 'Window', backgroundColor: 'WindowText' }, getHighContrastNoAdjustStyle()),
                        _b),
                },
                '.ms-Button.is-disabled': {
                    backgroundColor: palette.neutralLighter,
                    selectors: (_d = {},
                        _d[HighContrastSelector] = {
                            color: 'GrayText',
                            borderColor: 'GrayText',
                            backgroundColor: 'Window',
                        },
                        _d),
                },
                '.ms-Button.is-disabled + .ms-Button.is-disabled': {
                    backgroundColor: palette.neutralLighter,
                    border: 'none',
                    selectors: (_e = {},
                        _e[HighContrastSelector] = {
                            color: 'GrayText',
                            borderColor: 'GrayText',
                            backgroundColor: 'Window',
                        },
                        _e),
                },
            },
        },
    };
};
//# sourceMappingURL=DefaultButton.styles.js.map